var IS_MAP_SENTINEL="@@__IMMUTABLE_MAP__@@";export default function isMap(maybeMap){return!!(maybeMap&&maybeMap[IS_MAP_SENTINEL])}
//# sourceMappingURL=is-immutable-map.js.map